import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'parcels' });

export const { find, create, get, update, patch, reducer, remove } = actions;

export default reducer;
